export interface RuntimeConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain: string;
  graphqlUrl: string;
  appUrl: string;
}

declare global {
  interface Window {
    DILIGENCE_OS_CONFIG?: Partial<RuntimeConfig>;
  }
}

export const config: RuntimeConfig = {
  region: window.DILIGENCE_OS_CONFIG?.region ?? import.meta.env.VITE_AWS_REGION ?? 'us-east-1',
  userPoolId: window.DILIGENCE_OS_CONFIG?.userPoolId ?? import.meta.env.VITE_USER_POOL_ID ?? '',
  userPoolClientId: window.DILIGENCE_OS_CONFIG?.userPoolClientId ?? import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
  cognitoDomain: window.DILIGENCE_OS_CONFIG?.cognitoDomain ?? import.meta.env.VITE_COGNITO_DOMAIN ?? '',
  graphqlUrl: window.DILIGENCE_OS_CONFIG?.graphqlUrl ?? import.meta.env.VITE_GRAPHQL_URL ?? '',
  appUrl: window.DILIGENCE_OS_CONFIG?.appUrl ?? import.meta.env.VITE_APP_URL ?? window.location.origin,
};
